export default __webpack_public_path__ + "static/media/backed-web-body.2b3d6c52.webp";